import _get from 'lodash/get';

export const AuthStateSelector = state => _get(state, 'OVO.authState');

export const DeliveryIDSelector = state => _get(state, 'OVO.deliveryID');

export const TxnIDSelector = state => _get(state, 'OVO.txnID');

export const MFAURLSelector = state => _get(state, 'OVO.MFAURL');

export const TermURLSelector = state => _get(state, 'OVO.termURL');

export const AuthCodeSelector = state => _get(state, 'OVO.authCode');
